import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.timeout = setTimeout(() => {
      this.close();
    }, 10000); // 10 seconds
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout);
    }
  }

  close() {
    this.element.style.transition = "opacity 0.5s ease";
    this.element.style.opacity = "0";

    setTimeout(() => {
      this.element.remove();
    }, 500);
  }
}
